// src/components/ModalQR.jsx
import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const ModalQR = ({ code, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded shadow-lg max-w-sm w-full">
        <h3 className="text-xl font-semibold mb-4 text-center">Código: {code}</h3>
        <div className="flex justify-center mb-4">
          <QRCodeCanvas value={code} size={256} />
        </div>
        <button
          onClick={onClose}
          className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded transition-colors"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default ModalQR;
